import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Popconfirm, Tooltip, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toggleReportReviewComment } from '../../actions';
import { colors, rightSideBarColor } from '../../lib/theme';

class ReplyReport extends Component {

    toggleReport = () => {
        const { review, commentId, comment, userDetails } = this.props;
        const reportedArray = comment.reportedArray || [];
        const alreadyReported = userDetails.uid && (reportedArray.includes(userDetails.uid));
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to report the review.');
            return;
        }
        if (alreadyReported) {
            // this.props.toggleReportReviewComment(userDetails.uid, review.id, 'unreport');
            this.props.toggleReportReviewComment(review, commentId, userDetails, 'unreport');
        } else {
            this.props.toggleReportReviewComment(review, commentId, userDetails, 'report');
        }
    }

    render() {
        const { comment, userDetails } = this.props;
        const reportedArray = comment.reportedArray || [];
        const alreadyReported = userDetails.uid && (reportedArray.includes(userDetails.uid));

        return (
            <>
                <Tooltip title={alreadyReported ? 'Unreport' : 'Report'}>
                    <a onClick={this.toggleReport}>
                        {!alreadyReported && reportedArray.length > 0 && <span style={{ color: `${colors.danger}` }}>
                            <FontAwesomeIcon icon='flag' /> {reportedArray.length}
                        </span>}
                        {!alreadyReported && reportedArray.length < 1 && <span style={{ color: 'lightgray' }}>
                            <FontAwesomeIcon icon='flag' />
                        </span>}
                        {alreadyReported && <span style={{ color: `${colors.danger}` }}>
                            <FontAwesomeIcon icon='flag' />&nbsp;
                            {reportedArray.length == 1 && `You reported this`}
                            {reportedArray.length == 2 && `You and 1 other reported this`}
                            {reportedArray.length > 2 && `You and ${reportedArray.length - 1} others reported this`}
                        </span>}
                    </a>
                </Tooltip>
            </>
        )
    }
}

ReplyReport.propTypes = {
    userDetails: PropTypes.object,
    review: PropTypes.object.isRequired,
    commentId: PropTypes.string.isRequired,
    comment: PropTypes.object.isRequired,
    toggleReportReviewComment: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleReportReviewComment: bindActionCreators(toggleReportReviewComment, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplyReport)